import { en, type Dictionary } from './en';

export const DICTIONARIES: Record<string, Dictionary> = { en };

const loaders: Record<string, () => Promise<{ [key: string]: Dictionary }>> = {
  de: () => import('./de'),
  es: () => import('./es'),
  fr: () => import('./fr'),
  it: () => import('./it'),
  pt: () => import('./pt'),
  uk: () => import('./uk'),
  ar: () => import('./ar'),
};

export async function loadDictionary(locale: string): Promise<Dictionary | null> {
  if (DICTIONARIES[locale]) return DICTIONARIES[locale];
  const loader = loaders[locale];
  if (!loader) return null;
  try {
    const mod = await loader();
    const dict = (mod[locale] || (mod as any).default) as Dictionary;
    if (dict) {
      DICTIONARIES[locale] = dict;
      return dict;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Failed to load dictionary for ${locale}:`, e);
  }
  return null;
}

export { en };
export type { Dictionary };
